/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const PurchaseOrderStatus = {
  edit: {
    name: 'แก้ไขข้อมูล',
    color: 'warning',
    icon: 'border_color',
  },
  waiting: {
    name: 'ตรวจสอบราคา',
    color: 'primary',
    icon: 'price_check',
  },
  request: {
    name: 'ขออนุมัติ',
    color: 'info',
    icon: 'task_alt',
  },
  approve: {
    name: 'อนุมัติ',
    color: 'info',
    icon: 'task_alt',
  },
  reject: {
    name: 'ไม่อนุมัติ',
    color: 'error',
    icon: 'highlight_off_outlined',
  },
  purchase: {
    name: 'สั่งซื้อ',
    color: 'info',
    icon: 'task_alt',
  },
  receive: {
    name: 'รับบางส่วน',
    color: 'info',
    icon: 'task_alt',
  },
  success: {
    name: 'เสร็จสิ้น',
    color: 'success',
    icon: 'task_alt',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default PurchaseOrderStatus;
